// ===================================================================
// data/languages/asyncLoader.ts
// Chargement asynchrone des données de langue (code splitting Webpack).
// Chaque langue est importée dynamiquement dans un chunk séparé.
// Ne pas ajouter d'imports statiques de données de langue dans ce fichier.
// ===================================================================
import type { LanguageData, LanguageCode } from '../../types/types';

export const getLanguageDataAsync = async (code: LanguageCode): Promise<LanguageData> => {
  switch (code) {
    case 'wf': return (await import('./wolof')).default;
    case 'ba': return (await import('./bambara')).default;
    case 'la': return (await import('./lingala')).default;
    case 'ff': return (await import('./peul')).default;
    case 'co': return (await import('./copte')).default;
    case 'sw': return (await import('./swahili')).default;
    case 'ka': return (await import('./kama')).default;
    case 'yo': return (await import('./yoruba')).default;
    default:   throw new Error(`Language "${code}" not supported`);
  }
};
